module.exports = __webpack_public_path__ + "794830cf5e1969eb26674be99bb43011.webp";